"use strict"

import React, { useContext, useEffect, useState } from "react"
import { Button } from "react-bootstrap"

import { makeTagList } from "../../shared_components/table_filter_editor/utils"
import RunFilterEditorContainer from "../../shared_components/table_filter_editor/RunFilterEditorContainer"
import { getObjectsList } from "../../Loaders"
import { logToServer } from "../../ErrorBoundary"
import { AppSettingConfigContext } from "../../config/AppSettingsConfigProvider"

export default function RunFiltersEditor({
  filters,
  updateFilters,
  prevFilters,
  expProjectChange,
  disabled = false,
  intl,
}) {
  const app_config = useContext(AppSettingConfigContext)
  const { IS_PROJECT_EXPERIMENT_SITE = false } = (app_config?.config || {})?.settings || {}
  const [queryTags, setQueryTags] = useState([])
  const [sourceVocab, setSourceVocab] = useState([])
  const [run_metadata, setRunMetaData] = useState([])
  const [projectFilters, setProjectFilters] = useState({})

  useEffect(() => {
    getObjectsList("/warehouse/tags/active/")
      .then((tags) => {
        setQueryTags(tags)
      })
      .catch((err) => {
        console.error(err)
        logToServer(err)
      })

    getObjectsList("/warehouse/sources/")
      .then((vocab) => {
        setSourceVocab(vocab.filter((r) => ["Reactor", "System"].includes(r["source_type"])))
      })
      .catch((err) => {
        console.error(err)
        setSourceVocab([])
        logToServer(err)
      })

    getObjectsList("/warehouse/runs/get_metadata_keys/")
      .then((data) => {
        setRunMetaData(data.keys)
      })
      .catch((error) => {
        console.error(error)
        logToServer(error)
      })
  }, [])

  useEffect(() => {
    IS_PROJECT_EXPERIMENT_SITE &&
      getObjectsList("/warehouse/experiments/")
        .then((experiments) => {
          const getUniqueEntries = (field) => [...new Set(experiments.map((e) => e[field]))]
          setProjectFilters({
            project: ["All", ...getUniqueEntries("project_name").sort((a, b) => a.localeCompare(b))],
            task: ["All", ...getUniqueEntries("project_task_name").sort((a, b) => a.localeCompare(b))],
            netsuite_project: [
              "All",
              ...getUniqueEntries("project_netsuite_project_id").sort((a, b) => a.localeCompare(b)),
            ],
            experiment: ["All", ...getUniqueEntries("name").sort((a, b) => a.localeCompare(b))],
          })
        })
        .catch((err) => {
          logToServer(err)
          console.error(err)
        })
  }, [IS_PROJECT_EXPERIMENT_SITE, expProjectChange])

  const [tagVocab, setTagVocab] = useState([])

  useEffect(() => {
    setTagVocab(queryTags)
  }, [queryTags])

  const [tagList, setTagList] = useState([])

  useEffect(() => {
    setTagList(
      makeTagList(
        tagVocab,
        filters.filter((f) => f.tag).map((f) => f.tag),
        {
          reactor: ["All", ...sourceVocab.map((inst) => inst.name)],
          placeholder: ["All", "Yes", "No"],
          active: ["All", "Yes", "No"],
          ...projectFilters,
        },
        run_metadata,
        IS_PROJECT_EXPERIMENT_SITE ? [] : ["project", "task", "netsuite_project", "experiment"], // Don't present these options for non-Project/Experiment sites
      ),
    )
  }, [tagVocab, filters, sourceVocab, run_metadata, projectFilters])

  return (
    <div>
      {filters.map((filter, fi) => (
        <RunFilterEditorContainer
          key={fi}
          intl={intl}
          onDelete={() => updateFilters((filters) => filters.filter((f) => f !== filter))}
          onUpdate={(transition) =>
            updateFilters((filters) =>
              filters.map((filter, mapfi) => {
                if (mapfi === fi) {
                  return {
                    ...filter,
                    ...transition,
                  }
                } else {
                  return filter
                }
              }),
            )
          }
          tagList={tagList}
          filter={filter}
          prevFilter={prevFilters.filter((x) => x.tag === filter.tag)[0]}
        />
      ))}
      <Button
        variant={"outline-primary"}
        disabled={disabled}
        onClick={() => updateFilters((filters) => [...filters, {}])}
      >
        <span className={"fa fa-plus-circle"} />
        &nbsp;
        {intl.formatMessage({ id: "archiveddash.add.filter" })}
      </Button>
    </div>
  )
}
